// Querys and Mutations
import {
  GET_SIGNATURE_WITH_PAGINATION,
  SAVE,
  DELETE,
  UPDATE
} from '@/graphql/config/SignatureGraphql'

// models
import { SignatureForm, SignatureWithPagination, Signature } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class SignatureService {
  async getWithPagination (page: number, perPage: number): Promise<SignatureWithPagination> {
    const result = await apolloClient.query({
      query: GET_SIGNATURE_WITH_PAGINATION,
      variables: {
        first: perPage,
        page
      }
    })
    return {
      objects: result.data.signaturesWithPagination.data,
      pagination: result.data.signaturesWithPagination.paginatorInfo
    }
  }

  async save (body: SignatureForm): Promise<Signature> {
    const result = await apolloClient.mutate({
      mutation: SAVE,
      variables: {
        input: body
      }
    })
    return result.data.createSignature
  }

  async update (id: number, imageChange: boolean, body: SignatureForm): Promise<Signature> {
    const result = await apolloClient.mutate({
      mutation: UPDATE,
      variables: {
        input: body,
        id,
        imageChange
      }
    })
    return result.data.updateSignature
  }

  async delete (id: number): Promise<Signature> {
    const result = await apolloClient.mutate({
      mutation: DELETE,
      variables: {
        id
      }
    })
    return result.data.deleteSignature
  }
}

export default new SignatureService()
